export default class Vote {

  constructor($element, id, handlesClick) {

    /**
     * selectors of this class
     * @type {{value: string}}
     */
    this.SELECTORS = {
      value: '.js-vote-value',
    };

    /**
     * state classes
     * @type {{hasBeenClicked: string, active: string}}
     */
    this.CLASSES = {
      active: 'active',
      hasBeenClicked: 'voted',
      preventClick: 'prevent-click',
    };

    /**
     * elemetn of Vote
     */
    this.$ELEMENT = $element;

    /**
     * action of Vote
     */
    this.ACTION = this.$ELEMENT.attr('data-comment-action');

    /**
     * uid of Vote
     */
    this.UID = this.$ELEMENT.attr('data-comment-uid');

    /**
     * url of Vote
     */
    this.URL = this.$ELEMENT.attr('href');

    /**
     * number of Votes
     * @type {number}
     */
    this.VOTES = 0;

    /**
     * element which holds the votes
     */
    this.VALUE_$ELEMENT = $element.find(this.SELECTORS.value);

    /**
     * is Vote active
     * @type {boolean}
     */
    this.IS_ACTIVE = false;

    /**
     * has user clicked Vote
     * @type {boolean}
     */
    this.HAS_BEEN_CLICKED = false;

    /**
     * constant for the EVENT_TRIGGER
     * @type {string}
     */
    this.EVENT_TRIGGER = 'lin-socialize:vote:';

    /**
     * constant for the create and delete Event
     * @type {{create: CustomEvent, delete: CustomEvent}}
     */
    this.EVENT = new CustomEvent(this.EVENT_TRIGGER + this.ACTION, {
      bubbles: true,
      detail: {commentId: this.UID},
    });

    this.initComponents();
  }

  /**
   * Initialize components for Vote
   * @private
   * @example
   * this.initComponents()
   */
  initComponents() {
    let _this = this;
    return new Promise(resolve => {
      _this.getDefaultVotes();
      if (_this.isActive) _this.HAS_BEEN_CLICKED = true;
      resolve();
    });

  }

  /**
   * handle click on element
   */
  handleClick() {
    const _this = this;
    /*if (_this.isActive) {
      console.log('has been clicked')
      _this.decreaseVotes();
      _this.toggleHasBeenClicked();
    } else {
      _this.increaseVotes();
      _this.toggleHasBeenClicked();
    }
    _this.indicateVotesInMarkup();*/
    _this.triggerEvent();
    _this.sendRequest();
  }

  /**
   * prevent click
   */
  preventClick() {
    this.$ELEMENT.addClass(this.CLASSES.preventClick);
  }

  /**
   * enable click
   */
  enableClick() {
    this.$ELEMENT.removeClass(this.CLASSES.preventClick);
  }

  /**
   * set default number of votes
   */
  getDefaultVotes() {
    let votes = this.VALUE_$ELEMENT.html();
    this.VOTES = parseInt(votes);
  }

  /**
   * set votes
   * @param votes
   */
  setVotes(votes) {
    this.VOTES = votes;
  }

  /**
   * increase votes by 1
   */
  increaseVotes() {
    this.VOTES++;
  }

  /**
   * decrease votes by 1
   */
  decreaseVotes() {
    this.VOTES--;
  }

  /**
   * update votes in markup
   */
  indicateVotesInMarkup() {
    this.VALUE_$ELEMENT.html(this.VOTES);
  }

  /**
   * toggle if user has Vote clicked
   */
  toggleHasBeenClicked() {
    const _this = this;
    _this.HAS_BEEN_CLICKED = !_this.HAS_BEEN_CLICKED;
    if (_this.HAS_BEEN_CLICKED) _this.$ELEMENT.addClass(_this.CLASSES.hasBeenClicked);
    else _this.$ELEMENT.removeClass(_this.CLASSES.hasBeenClicked);
  }

  /**
   * remove the state that user has Vote clicked
   */
  removeHasBeenClicked() {
    this.HAS_BEEN_CLICKED = false;
    this.$ELEMENT.removeClass(this.CLASSES.hasBeenClicked);
  }

  /**
   * set vote active
   */
  setActive() {
    this.IS_ACTIVE = true;
    this.$ELEMENT.addClass(this.CLASSES.active);
  }

  /**
   * remove active state
   */
  removeActiveState() {
    this.IS_ACTIVE = false;
    this.$ELEMENT.removeClass(this.CLASSES.active);
  }

  /**
   * send request
   */
  sendRequest() {
    const _this = this;
    let request = {
      tx_linsocialize_index: {
        controller: 'Comment',
        action: _this.ACTION,
        comment: _this.UID
      }
    };

    $.ajax({
      url: _this.URL,
      type: 'POST',
      dataType: 'json',
      data: request,
      success: function(result) {

        let state = result.state,
            count = result.count;

        if (state === 'active') _this.setActive();
        if (state === 'default') _this.removeActiveState();

        _this.setVotes(count);
        _this.indicateVotesInMarkup();
      },
      complete: function() {
        _this.enableClick();
      }
    })
  }

  /**
   * update votes by indicate number of votes in markup and update states
   */
  updateVote() {
    let _this = this;
    _this.indicateVotesInMarkup();
    if (_this.VOTES > 0) {
      _this.setActive();
    } else {
      _this.removeActiveState();
      _this.removeHasBeenClicked();
    }
  }

  /**
   * trigger specific event
   */
  triggerEvent() {
    document.querySelector('body').dispatchEvent(this.EVENT);
  }

  /**
   * get if vote is active
   * @return {*}
   */
  get isActive() {
    return this.$ELEMENT.hasClass(this.CLASSES.active);
  }

  /**
   * get $element
   * @return {*}
   */
  get $element() {
    return this.$ELEMENT;
  }

  /**
   * get if user has vote clicked
   * @return {boolean}
   */
  get hasBeenClicked() {
    return this.HAS_BEEN_CLICKED;
  }

}
